import { render, staticRenderFns } from "./TabbarContent.vue?vue&type=template&id=91c4fc32&"
import script from "./TabbarContent.vue?vue&type=script&lang=js&"
export * from "./TabbarContent.vue?vue&type=script&lang=js&"
import style0 from "./TabbarContent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports